import * as React from 'react';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import { UserState } from '../../store/user/types';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import ConfigureRoles from '../../components/admin/ConfigureRoles';
import AllowedRoles, { AllowedRoleType } from '../../components/admin/AllowedRoles';
// import RolesTable from '../../components/admin/RolesTable.jsx';
import { Modal } from 'react-bootstrap';
import Loader from '../../components/common/Loader';
import { qsStringify } from '../../utilities/helper';
import AxiosConfig from '../../utilities/AxiosConfig';
import axios from 'axios';
import logger from '../../utilities/logging';
import "./RoleManagement.css"

export type RoleType = {
    PortalRoleId: number,
    RoleName: string,
    Description: string,
    RoleCategory: string,
    MapToLPRoleCsv: string,
    IsProtected: boolean,
    CreatedDate: string,
    CreatedBy: string,
    ModifyDate: string,
    ModifiedBy: string,
    DeletedDate: string | null,
    DeletedBy: string | null,
    DisabledDate: string | null,
    DisabledBy: string | null,
}

export interface RoleManagementProps {
    user: UserState,
}

export interface RoleManagementState {
    file: any,
    uploadingSettings: boolean,
    modalOpen: boolean,
    filePreview: string,
    importedRoles: Array<RoleType>,
    importedAllowedRoles: Array<AllowedRoleType>,
    loadingRoleSettings: boolean,
    uploadingMessage: string,
    exportingFile: boolean,
}

class RoleManagement extends React.Component<RoleManagementProps, RoleManagementState> {
    constructor(props: RoleManagementProps) {
        super(props);
        this.state = {
            file: null,
            uploadingSettings: false,
            modalOpen: false,
            filePreview: "",
            importedRoles: [],
            importedAllowedRoles: [],
            loadingRoleSettings: false,
            uploadingMessage: "",
            exportingFile: false,
        }
    }

    exportSettings = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        try {
            const download = {
                roles: await this.getRoles(),
                allowedRoles: await this.getAllowedRoles(),
            }
            let a = document.createElement("a");
            a.href = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(download));
            a.target = "_Blank";
            a.download = "RoleSettings.json";
            a.click();
            //console.log("Done Downloading");
        } catch (err) {
            logger.Error({
                EventMessage: `RoleManagement -> ExportSettings -> Error : ${JSON.stringify(err)}`,
                EventCategory: "exportsettings"
            });
        }
    }

    clickedImport = (e: React.SyntheticEvent): void => {
        e.preventDefault();
        let btn = document.getElementById('selectedFile');
        btn && btn.click();
    }

    onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (files !== null) {
            this.setState({ file: files[0], modalOpen: true });
            let reader = new FileReader();
            reader.onload = this.onReaderLoad;
            reader.readAsText(files[0]);
        }
    }

    onReaderLoad = (event: any) => {
        if (event.target.result) {
            this.setState({ filePreview: event.target.result, loadingRoleSettings: true });
            let object = JSON.parse(event.target.result);
            if (object.roles && object.allowedRoles) {
                this.setState({
                    importedRoles: object.roles,
                    importedAllowedRoles: object.allowedRoles,
                    loadingRoleSettings: false,
                })
            } else {
                alert("File doesn't seem to match correct syntax.");
            }
        } else {
            alert("There was an error reading the file");
        }
    }

    submitSettings = async (shouldOverwrite: boolean) => {
        const { importedRoles, importedAllowedRoles } = this.state;
        this.setState({ uploadingSettings: true, uploadingMessage: "Starting Upload" });
        if (shouldOverwrite) {
            this.setState({ uploadingMessage: "Removing Old Roles" });
            this.deleteOldMakePosts();
        }
        else {
            this.setState({ uploadingMessage: "Creating Request" });
            this.makePostRequests(importedRoles, "role");
            this.makePostRequests(importedAllowedRoles, "allowedrole");
            setTimeout(() => {
                this.setState({
                    uploadingSettings: false,
                    file: null,
                    importedAllowedRoles: [],
                    importedRoles: [],
                    uploadingMessage: "",
                    modalOpen: false,
                });
            }, 1000)
        }
        alert("Refresh may be needed to see changes.");
    }

    makePostRequests = (roles: Array<RoleType> | Array<AllowedRoleType>, url: string) => {
        let breakException = {};
        const config = AxiosConfig.configValue();
        try {
            roles.forEach((role: RoleType | AllowedRoleType) => {
                const requestBody = qsStringify(role);
                axios.post(process.env.REACT_APP_API_URL + `/api/portal/${url}`, requestBody, config)
                    .then(response => {
                        this.setState({ uploadingMessage: `Finished Uploading` });
                    })
                    .catch(error => {
                        if (error.response.status === 500) {
                            alert("already exists. Will skip this one.");
                        } else {
                            alert("Error adding" + url);
                            throw breakException;
                        }
                    })
            })
        } catch (error) {
            //console.log(error);
            logger.Error({
                EventMessage: `RoleManagement -> makePostRequests -> Error : ${JSON.stringify(error)}`,
                EventCategory: "makepostrequests"
            });
        }
    }

    getRoles = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL + "/api/portal/role/*",
                AxiosConfig.configValue()
            );
            //console.log("r", response.data);
            return response.data;
        } catch (error) {
            logger.Error({
                EventMessage: `RoleManagement -> getRoles -> Error : ${JSON.stringify(error)}`,
                EventCategory: "getroles"
            });
        }
    }

    getAllowedRoles = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL + "/api/portal/allowedrole/*",
                AxiosConfig.configValue()
            );
            //console.log("AR", response.data)
            return response.data;
        } catch (error) {
            logger.Error({
                EventMessage: `RoleManagement -> getAllowedRoles -> Error : ${JSON.stringify(error)}`,
                EventCategory: "getallowedroles"
            });
        }
    }

    deleteOldMakePosts = () => {
        const { importedRoles, importedAllowedRoles } = this.state;
        const requestBody = qsStringify({
            client_id: process.env.REACT_APP_CLIENT_ID
        })
        axios.post(process.env.REACT_APP_API_URL + "/api/portal/resetportalsettings", requestBody, AxiosConfig.configValue())
            .then(response => {
                this.setState({ uploadingMessage: "Finished Removing Old Roles" });
            })
            .then(() => {
                this.setState({ uploadingMessage: "Creating Request" });
                this.makePostRequests(importedRoles, "role");
                this.makePostRequests(importedAllowedRoles, "allowedrole");
                setTimeout(() => {
                    this.setState({
                        uploadingSettings: false,
                        file: null,
                        importedAllowedRoles: [],
                        importedRoles: [],
                        uploadingMessage: "",
                        modalOpen: false,
                    });
                }, 1000)
            })
            .catch(error => {
                //console.log(error, error.response);
                alert("There was an error deleting the old roles.");
                logger.Error({
                    EventMessage: `RoleManagement -> deleteOldMakePosts -> Error : ${JSON.stringify(error)}`,
                    EventCategory: "deleteoldmakeposts"
                });
            })
    }

    toggleModal = () => {
        this.setState({ modalOpen: !this.state.modalOpen });
    }

    render() {
        const {
            uploadingSettings,
            modalOpen,
            filePreview,
            loadingRoleSettings,
            uploadingMessage,
            exportingFile
        } = this.state;
        return (
            <div className="RoleManagemnet main-content col-sm">
                <Tab.Container id="left-tabs-example" defaultActiveKey="roles">
                    <Nav variant="tabs" className="flex-row w-100 bg-secondary">
                        <Nav.Item>
                            <Nav.Link className="text-dark" eventKey="roles">Configure Roles</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link className="text-dark" eventKey="allowedRoles">Configure Allowed Roles</Nav.Link>
                        </Nav.Item>
                        {/* <Nav.Item>
                            <Nav.Link className="text-dark" eventKey="users">Configure Users</Nav.Link>
                        </Nav.Item> */}
                        <Nav.Item className="ml-auto">
                            <input onChange={this.onChangeHandler} accept="application/JSON" type="file" id="selectedFile" style={{ display: "none" }} />
                            <Button variant="primary" onClick={this.clickedImport}>Import Settings</Button>
                            <Button disabled={exportingFile} onClick={this.exportSettings} variant="primary">Export Settings</Button>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane eventKey="roles" unmountOnExit mountOnEnter>
                            <ConfigureRoles />
                        </Tab.Pane>
                        <Tab.Pane eventKey="allowedRoles" unmountOnExit mountOnEnter>
                            <AllowedRoles />
                        </Tab.Pane>
                        {/* <Tab.Pane eventKey="users" unmountOnExit mountOnEnter>
                            <ConfigureUsers />
                        </Tab.Pane> */}
                    </Tab.Content>
                </Tab.Container>

                <Modal show={modalOpen} onHide={this.toggleModal} className="z-100">
                    <Modal.Header>
                        <Modal.Title>Import Settings</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: "500px", overflowY: "scroll" }}>
                        {
                            filePreview
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {
                            uploadingSettings
                                ?
                                <Loader title={uploadingMessage} />
                                :
                                <>
                                    <Button variant="secondary" onClick={this.toggleModal}>
                                        Close
                                    </Button>
                                    <Button disabled={loadingRoleSettings} onClick={() => this.submitSettings(true)}>Save and Overwrite</Button>
                                    <Button disabled={loadingRoleSettings} onClick={() => this.submitSettings(false)}>Save and Merge</Button>
                                </>
                        }
                    </Modal.Footer>
                </Modal>
            </div>

        );
    }
}

const mapStateToProps = (state: AppState) => ({
    user: state.user
})

export default connect(mapStateToProps)(RoleManagement);